import settingsActionCreatorFactory from 'typescript-fsa'
import { Theme } from '@mui/material'
import { Message } from '@professocial/professocialTypes/types/messageTypes'

import { ActionCall, GeneralPostingOptions, SocialMediaNetwork } from '@professocial/professocialTypes/types/commonTypes'
import { TopicsWithMetadataResponse } from '@3m5/sm_publish-frontend-api/models/TopicsWithMetadataResponse'
import { PostingConfiguration } from '@professocial/professocialTypes/types/configurationTypes'

export const commonActionCreator = settingsActionCreatorFactory('SETTINGS')

/**
 * Actions
 */

// common actions
export const setTheme = commonActionCreator<Theme>('SET_THEME')
export const setUser = commonActionCreator<any>('SET_USER')
export const setGeneralPostingOptions = commonActionCreator<GeneralPostingOptions>('SET_GENERAL_POSTING_OPTIONS')
export const setPostingConfiguration = commonActionCreator<PostingConfiguration>('SET_POSTING_CONFIGURATION')
export const setSocialMediaNetworks = commonActionCreator<SocialMediaNetwork>('SET_SOCIAL_MEDIA_NETWORKS')
export const setMessage = commonActionCreator<Message>('SET_MESSAGE')

export const requestStarted = commonActionCreator<ActionCall>('REQUEST_STARTED')
export const requestFinished = commonActionCreator<ActionCall>('REQUEST_FINISHED')
export const requestFailed = commonActionCreator<ActionCall>('REQUEST_FAILED')
export const clearRequests = commonActionCreator('CLEAR_REQUESTS')

export const getTopicsAndMetadataForCurrentUserInitiated = commonActionCreator('GET_ABO_TOPICS_INITIATED')
export const getTopicsAndMetadataForCurrentUser = commonActionCreator.async<undefined, TopicsWithMetadataResponse>('GET_ABO_TOPICS')
